export default {
  'social_video': {
    '***': {
      extraFilter: {
        type: 'metadataFilter',
        ad_type: ['***'],
        disabledState: 'disabled', // 'hidden'
        data: {
          field: 'length',
          title: 'Ad Length',
          options: [
            {
              label: '15 or less',
              value: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
              selected: true
            },
            {
              label: '30',
              value: 30,
              selected: true
            },
            {
              label: '60',
              value: 60,
              selected: true
            },
            {
              label: 'Other',
              value: 'other',
              selected: true
            }
          ]
        }
      }
    }
  },
  'social_post': {
    '***': {
      extraFilter: {
        type: 'metadataFilter',
        ad_type: ['***'],
        disabledState: 'disabled', // 'hidden'
        data: {
          field: 'length',
          title: 'Ad Length',
          options: [
            {
              label: '15 or less',
              value: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
              selected: true
            },
            {
              label: '30',
              value: 30,
              selected: true
            },
            {
              label: '60',
              value: 60,
              selected: true
            },
            {
              label: 'Other',
              value: 'other',
              selected: true
            }
          ]
        }
      }
    }
  },
  'disney_radio': {
    '***': {
      extraFilter: {
        type: 'metadataFilter',
        ad_type: ['***'],
        disabledState: 'disabled', // 'hidden'
        data: {
          field: 'length',
          title: 'Ad Length',
          options: [
            {
              label: '15 or less',
              value: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
              selected: true
            },
            {
              label: '30',
              value: 30,
              selected: true
            },
            {
              label: '60',
              value: 60,
              selected: true
            },
            {
              label: 'Other',
              value: 'other',
              selected: true
            }
          ]
        }
      }
    }
  },
  'disney_ooh': {
    '***': {
      extraFilter: {
        type: 'metadataFilter',
        ad_type: ['***'],
        disabledState: 'disabled', // 'hidden'
        data: {
          field: 'length',
          title: 'Ad Length',
          options: [
            {
              label: '15 or less',
              value: [6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
              selected: true
            },
            {
              label: '30',
              value: 30,
              selected: true
            },
            {
              label: '60',
              value: 60,
              selected: true
            },
            {
              label: 'Other',
              value: 'other',
              selected: true
            }
          ]
        }
      }
    }
  }
};




// WEBPACK FOOTER //
// ./src/app/configuration/DisneyHulu/config/components/selection/Search/SearchFilter.js